import { CssBaseline, ThemeProvider } from '@mui/material';
import { ReactElement, ReactNode } from 'react';
import { darkTheme, lightTheme } from '../utils/customTheme';
import { useSelector } from 'react-redux';
import { ReduxRootStateType } from '../redux/store';

type Children_Type = ReactNode | ReactElement;

interface Component_Prop_Type {
  children: Children_Type;
}

function CustomThemeProvider({ children }: Component_Prop_Type) {
  // redux store hook to read the theme preference
  const current_theme = useSelector(
    (state: ReduxRootStateType) => state.user.user_info?.theme ?? 'dark'
  );

  return (
    <ThemeProvider theme={current_theme === 'dark' ? darkTheme : lightTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}

export default CustomThemeProvider;
